module.exports = __webpack_public_path__ + "media/images/ecalls/icon_checked_circle_ice-1c368416df4fe6f24c07a67ce961ed46.png";